import { SpotFillRateLineChart } from '@frontend/chart/components';
import { Application, Feature } from '@frontend/functionality/types';
import { FormattedMessage, useIntl } from 'react-intl';

import { StatisticsCard } from '../../shared';
import { useLast30DaysPudoSpotFillRateLineChart } from './use-last-30-days-pudo-spot-fill-rate-line-chart';

export interface Last30DaysPudoSpotFillRateLineChartProps {
    accountId: string;
    navigateUrl?: string;
    application?: Application;
    /** When set, limits occupancy to that feature (e.g. Nivaliz urns = outbound). */
    feature?: Feature;
}

export const Last30DaysPudoSpotFillRateLineChart = (props: Last30DaysPudoSpotFillRateLineChartProps) => {
    const intl = useIntl();
    const { data, isLoading, navigateUrl } = useLast30DaysPudoSpotFillRateLineChart(props);
    const referenceLabel = intl.formatMessage(
        props.application === Application.NIVALIZ
            ? {
                  id: 'platform.statistics.pudo.last-30-days-pudo-spot-fill-rate-line-chart.slot-capacity-reference',
                  description: 'Label for the horizontal SLOT capacity reference line on the distriSPOT occupancy chart',
                  defaultMessage: 'SLOT capacity'
              }
            : {
                  id: 'platform.statistics.pudo.last-30-days-pudo-spot-fill-rate-line-chart.pudo-slot-capacity-reference',
                  description: 'Label for the horizontal PuDo SLOT capacity reference line on the distriSPOT occupancy chart',
                  defaultMessage: 'PuDo SLOT capacity'
              }
    );

    return (
        <StatisticsCard
            chartKey={SpotFillRateLineChart.definition.key}
            navigateUrl={navigateUrl}
            title={
                <FormattedMessage
                    id='platform.statistics.pudo.last-30-days-pudo-spot-fill-rate-line-chart.title'
                    description='Title of the PuDo dashboard chart showing occupied distriSPOT SLOTs over the last 30 days versus SLOT capacity'
                    defaultMessage='distriSPOT occupancy'
                />
            }
            isLoading={isLoading}
            hasData={!!data}>
            {data && (
                <div className='mt-auto h-full min-h-0 w-full flex-1'>
                    <SpotFillRateLineChart
                        data={data}
                        minHeight={80}
                        showLabels='minimal'
                        tooltipShared
                        referenceLabel={referenceLabel}
                    />
                </div>
            )}
        </StatisticsCard>
    );
};
